/**
 * OrbitalDemo - Demo page for the Orbital Carousel prototype
 *
 * Access at: /orbital-demo
 *
 * This showcases the "Intimate Intelligence" design direction:
 * - Warm paper aesthetic with intelligent gold accents
 * - Missions orbit around YOU at the center
 * - The most relevant mission is "pulled forward" into focus
 */

import { OrbitalCarousel, type Mission } from '../components/OrbitalCarousel';

// Sample missions demonstrating different types
const demoMissions = [
  {
    id: '1',
    emoji: '🎫',
    title: 'The National',
    subtitle: 'Greek Theatre · Mar 15',
    detail: '$65',
    matchPercent: 94,
    insight: "You've seen them twice before and loved it.",
  },
  {
    id: '2',
    emoji: '✈️',
    title: 'Tokyo Trip',
    subtitle: '23% off flights · April',
    matchPercent: 87,
    insight: 'You researched Japan trips 3 times last month.',
  },
  {
    id: '3',
    emoji: '☕',
    title: 'Coffee Sub',
    subtitle: 'Blue Bottle · $12/mo',
    matchPercent: 82,
    insight: 'Your coffee spend correlates with busy weeks.',
  },
  {
    id: '4',
    emoji: '📚',
    title: 'Book Club',
    subtitle: 'Sci-fi readers nearby',
    matchPercent: 76,
    insight: 'You read 3 sci-fi books in the last 2 months.',
  },
  {
    id: '5',
    emoji: '🔋',
    title: 'GreenEnergy',
    subtitle: 'Save $47/year',
    matchPercent: 71,
    insight: 'Your electricity bill is due tomorrow.',
  },
  {
    id: '6',
    emoji: '🏃',
    title: 'Morning Run',
    subtitle: 'Group near you · 6am',
    matchPercent: 68,
    insight: 'Your fitness activity peaks on weekday mornings.',
  },
];

export function OrbitalDemo() {
  const handleMissionAction = (mission: Mission, action: 'accept' | 'dismiss') => {
    console.log(`Mission "${mission.title}" ${action}ed`);
  };

  return (
    <OrbitalCarousel
      missions={demoMissions}
      userName="Nick"
      onMissionAction={handleMissionAction}
    />
  );
}

export default OrbitalDemo;
